import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { compose } from 'redux'
import styles from './main.module.scss'
import ImageSlider from './imageSlider/imageSlider'
import ItemSlider from './itemSlider/itemSlider'
import withRouter from '../../hooks/withRouter'
import { RootState } from '../../redux/store'
import { getMainSliderImages } from '../../redux/main.slice'
import { SliderImages } from '../../types/sliderImages'
import { loadNewBooks, loadPopularBooks } from '../../redux/book.slice'
import { Book } from '../../types/book'
import SimpleSlider from '../commons/simpleSlider/simpleSlider'
import { loadAllAuthors } from '../../redux/author.slice'
import { loadAllPublishers } from '../../redux/publisher.slice'
import CommentsBlock from '../commons/commentsBlock/commentsBlock'
// import { getMainSliderImages } from '../../redux/mainReducer/mainReducer'
// import SimpleSlider from '../commons/simpleSlider/simpleSlider'
// import CommentsBlock from '../commons/commentsBlock/commentsBlock'
// import { getAuthors } from '../../redux/authorReducer/authorReducer'
// import { getPublishers } from '../../redux/publisherReducer/publisherReducer'
// import { getNewBooks } from '../../redux/bookReducer/bookReducer'
// import { getComments } from '../../redux/commentReducer/commentReducer'
// import { getUserAuthorizedId } from '../../redux/userReducer/userReducer'

interface MainProps {
  mainSliderImagesUrl: string[]
  mainSliderImagesLoaded: boolean
  getMainSliderImages: any
  authors: any
  getPublishers: any
  publishers: any
  sliderBooks: any
  comments: any
  getComments: any
  getUserAuthorizedId: any
  userAuthorizedId: any
  words: any
  newBooks: Book[]
  popularBooks: Book[]
  loadAllAuthors: () => void
  loadAllPublishers: () => void
  loadPopularBooks: () => void
  loadNewBooks: (count: number) => void
}

const Main = (props: MainProps) => {
  const {
    mainSliderImagesUrl,
    mainSliderImagesLoaded,
    getMainSliderImages,
    authors,
    getPublishers,
    publishers,
    sliderBooks,
    comments,
    getComments,
    getUserAuthorizedId,
    userAuthorizedId,
    words,
    newBooks,
    popularBooks,
    loadAllAuthors,
    loadAllPublishers,
    loadPopularBooks,
    loadNewBooks,
  } = props

  const [selectedBookTab, setSelectedBookTab] = useState<string>('new')

  useEffect(() => {
    loadNewBooks(10)
    loadPopularBooks()
    loadAllAuthors()
    loadAllPublishers()
    getMainSliderImages()
    // getComments()
    // getUserAuthorizedId()
  }, [])

  return (
    <div className={styles.container}>
      {/* @ts-ignore */}
      <ImageSlider
        mainSliderImages={mainSliderImagesLoaded && mainSliderImagesUrl}
      />
      {/* @ts-ignore */}
      <ItemSlider
        items={selectedBookTab === 'new' ? newBooks : popularBooks}
        onTabSelect={setSelectedBookTab}
      />
      {/* @ts-ignore */}
      <SimpleSlider
        title={words.ourAuthors}
        items={authors}
        category="authors"
      />
      <SimpleSlider
        title={words.ourPublishers}
        items={publishers}
        category="publishers"
      />
      {/* @ts-ignore */}
      {/* <CommentsBlock comments={comments} userId={userAuthorizedId} /> */}
    </div>
  )
}

let mapStateToProps = (state: RootState) => {
  return {
    mainSliderImagesUrl: state.main.mainSliderImagesUrl,
    mainSliderImagesLoaded: state.main.mainSliderImagesLoaded,
    language: state.main.language,
    newBooks: state.book.newBooks,
    popularBooks: state.book.popularBooks,
    authors: state.author.authors,
    publishers: state.publisher.publishers,
    // sliderBooks: state.book.sliderBooks,
    // comments: state.comment.comments,
    // userAuthorizedId: state.user.userAuthorizedId,
    words: state.main.words,
  }
}

export default compose(
  connect(mapStateToProps, {
    getMainSliderImages,
    loadAllAuthors,
    loadAllPublishers,
    loadNewBooks,
    loadPopularBooks,
    // getComments,
    // getUserAuthorizedId,
  }),
  withRouter,
)(Main)
